module.exports = __webpack_public_path__ + "img/desktop.db9f6511.jpeg";